import React, { Component } from "react";
import { connect } from "react-redux";
import { Icon, Progress, Button } from "semantic-ui-react";
import SRHCopyright from "./../../../../components/SRHCopyright";
import ReportHeader from "./../ReportHeader";
import Printable from "./../../../../components/Printable";
import { Wrapper, BigButton, ProgressWrap, Question, Bar, SectionActions, Domain } from "./style.js";
import arrow from "./../../../../assets/img/blue-arrow.png";
import _ from "lodash";

class Questions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAllQuestionPercentiles: false,
    };
    this.getPage = this.getPage.bind(this);
    this.displayPercentile = this.displayPercentile.bind(this);
  }

  getPage(domains, pageNumber, magnetReport, unit) {
    const { page } = this.props;
    const { totalRespondents, datasetName, workSettingsSurveyed, survey } = magnetReport;
    const key = `page-${key}`;
    if (pageNumber === 0) {
      return (
        <Printable key={key} page={page + pageNumber}>
          <SectionActions>
            {/* <Button onClick={this.props.toggleShowAllQuestions}>
              <Icon name="close" /> Hide Section
            </Button>
            <Button onClick={this.props.toggleShowAllQuestionPercentiles}>
              <Icon name="percent" /> {showAllQuestionPercentiles ? "Hide Percentiles" : "Display Percentiles"}
            </Button> */}
          </SectionActions>
          <ReportHeader
            title={`All ${survey} Items`}
            totalRespondents={totalRespondents}
            workSettingsSurveyed={workSettingsSurveyed}
            datasetName={datasetName}
            unit={unit}
            magnetReport={magnetReport}
          />
          {domains}
          <SRHCopyright textClass="large-font" />
        </Printable>
      );
    } else {
      return (
        <Printable key={key} page={page + pageNumber}>
          <ReportHeader
            title={`All ${survey} Items (cont.)`}
            totalRespondents={totalRespondents}
            workSettingsSurveyed={workSettingsSurveyed}
            datasetName={datasetName}
            unit={unit}
            magnetReport={magnetReport}
          />
          {domains}
          <SRHCopyright textClass="large-font" />
        </Printable>
      );
    }
  }

  displayPercentile(percentile) {
    if (percentile === 11 || percentile === 12 || percentile === 13) {
      return `${percentile}th`;
    } else if (percentile % 10 === 1) {
      return `${percentile}st`;
    } else if (percentile % 10 === 2) {
      return `${percentile}nd`;
    } else if (percentile % 10 === 3) {
      return `${percentile}rd`;
    } else {
      return `${percentile}th`;
    }
  }

  render() {
    const {
      questions,
      unit,
      magnetReport,
      showAllQuestions,
      showAllQuestionPercentiles,
      showAllQuestionInlineValues,
    } = this.props;
    const { survey, surveyQuestions, domainPrefixes, comparativeDatasets } = magnetReport;

    if (showAllQuestions) {
      if (questions.fetched) {
        const currentDataset = _.filter(
          _.map(comparativeDatasets && comparativeDatasets.split("||"), function(dataset) {
            return { year: dataset.split("|")[0], id: dataset.split("|")[1] };
          }),
          function(dataset) {
            return dataset.id === "this";
          }
        )[0];
        const currentGroupName = currentDataset && currentDataset.year;

        const prevDataset = _.reduce(
          _.map(comparativeDatasets && comparativeDatasets.split("||"), function(dataset) {
            return { year: dataset.split("|")[0], id: dataset.split("|")[1] };
          }),
          function(highest, next) {
            return (highest.year < next.year || highest.id === "this") && next.id !== "this" ? next : highest;
          }
        );
        const prevGroupName = prevDataset && prevDataset.year;

        const domains = [
          { code: "magnet_quality", name: "Fundamentals of Quality Nursing Care" },
          { code: "magnet_leadership", name: "Leadership Access and Responsiveness" },
          { code: "magnet_autonomy", name: "Autonomy" },
          { code: "magnet_interprof", name: "Interprofessional Relationships" },
          { code: "magnet_teamwork", name: "RN-to-RN Teamwork and Collaboration" },
          { code: "magnet_prof_dev", name: "Professional Development" },
          { code: "magnet_resources", name: "Adequacy of Resources and Staffing" },
        ];
        const domainComponents = {};
        for (let i = 0; i < domains.length; i++) {
          const domain = domains[i];
          let yoy = false;
          const questionComponents = _.chain(surveyQuestions)
            .filter(question => {
              return question.domain === domain.code;
            })
            .map(question => {
              const results = questions.questions[question.column];
              let positiveIndex = -1;
              let neutralIndex = -1;
              let negativeIndex = -1;
              let strainedIndex = -1;
              _.forEach(results.data, function(point, index) {
                if (point.name === "Percent Positive") {
                  positiveIndex = index;
                } else if (point.name === "Percent Neutral") {
                  neutralIndex = index;
                } else if (point.name === "Percent Negative") {
                  negativeIndex = index;
                } else if (point.name === "Percent Strained") {
                  strainedIndex = index;
                }
              });

              let currentIndex = -1;
              let prevIndex = -1;
              if (comparativeDatasets) {
                _.forEach(results.data[0].data, function(point, index) {
                  if (point.group_name === currentGroupName) {
                    currentIndex = index;
                  } else if (point.group_name === prevGroupName) {
                    prevIndex = index;
                  }
                });
              } else {
                currentIndex = 0;
              }

              let positive = 0;
              let neutral = 0;
              let negative = 0;
              let strained = 0;
              let change = 0;
              if (
                (positiveIndex > -1 && results.data[positiveIndex].data[currentIndex]) ||
                (strainedIndex > -1 && results.data[strainedIndex].data[currentIndex])
              ) {
                if (positiveIndex > -1) {
                  positive = results.data[positiveIndex].data[currentIndex].percent;
                }
                if (neutralIndex > -1) {
                  neutral = results.data[neutralIndex].data[currentIndex].percent;
                }
                if (negativeIndex > -1) {
                  negative = results.data[negativeIndex].data[currentIndex].percent;
                }
                if (strainedIndex > -1) {
                  strained = results.data[strainedIndex].data[currentIndex].percent;
                }
                const showChange = positiveIndex > -1 && prevIndex > -1;
                if (showChange) {
                  change = positive - results.data[positiveIndex].data[prevIndex].percent;
                  yoy = true;
                }
                results.column = question.column;
                results.showPosNeuNeg = positiveIndex > -1;
                results.showStrain = strainedIndex > -1;
                results.positive = positive;
                results.neutral = neutral;
                results.negative = negative;
                results.strained = strained;
                results.showChange = showChange;
                results.change = change;
                results.percentile = results.data[0].benchmarks[0] ? results.data[0].benchmarks[0].percentile : 0;
              } else {
                results.insufficientData = true;
              }
              return results;
            })
            .sortBy(results => {
              return results.percentile;
            })
            .sortBy(results => {
              if (results.showStrain) {
                return results.percentile;
              } else {
                return results.neutral * -1;
              }
            })
            .sortBy(results => {
              if (results.showStrain) {
                return results.strained;
              } else {
                return results.positive * -1;
              }
            })
            .map(results => {
              const {
                column,
                question,
                showPosNeuNeg,
                showStrain,
                positive,
                neutral,
                negative,
                strained,
                showChange,
                change,
                percentile,
                insufficientData,
              } = results;
              return (
                <Question key={column}>
                  <p>{question}</p>
                  {showPosNeuNeg && (
                    <div className="data">
                      <div className={`percent ${showChange ? "make-room" : ""}`}>{positive}%</div>
                      {showChange && (
                        <div className={`percent-change ${change > 0 ? "positive" : change < 0 ? "negative" : ""}`}>
                          {Math.abs(change)}%{change > 0 ? " ↑" : change < 0 ? " ↓" : ""}
                        </div>
                      )}
                      <Bar
                        className="positive"
                        data-tooltip={`${positive}% Positive`}
                        style={{ width: `${positive * 2}px` }}
                      />
                      <Bar
                        className="neutral"
                        data-tooltip={`${neutral}% Neutral`}
                        style={{ width: `${neutral * 2}px` }}
                      >
                        {showAllQuestionInlineValues && neutral > 0 && <div className="value">{neutral}%</div>}
                      </Bar>
                      <Bar
                        className="negative"
                        data-tooltip={`${negative}% Negative`}
                        style={{ width: `${negative * 2}px` }}
                      >
                        {showAllQuestionInlineValues &&
                          negative > 0 && (
                            <div className="value" style={{ color: "#fff" }}>
                              {negative}%
                            </div>
                          )}
                      </Bar>
                      {showAllQuestionPercentiles && (
                        <div className="percentile">{this.displayPercentile(percentile)}</div>
                      )}
                    </div>
                  )}
                  {showStrain && (
                    <div className="data">
                      <div className="percent">{strained}%</div>
                      <Bar data-tooltip={`${strained}% Strained`} style={{ width: `${strained * 2}px` }} />
                      <Bar className="gray" style={{ width: `${200 - strained * 2}px` }}>
                        {showAllQuestionInlineValues && strained > 0 && <div className="value" />}
                      </Bar>
                      {showAllQuestionPercentiles && (
                        <div className="percentile">{this.displayPercentile(percentile)}</div>
                      )}
                    </div>
                  )}
                  {insufficientData && (
                    <div className="data" style={{ fontSize: "12px", top: "10px", color: "#999" }}>
                      Insufficient number of responses to display results.
                    </div>
                  )}
                </Question>
              );
            })
            .value();
          domainComponents[domain.code] = (
            <Domain key={domain.code}>
              <div className="header" style={{ top: domainPrefixes[domain.code] ? "4px" : "" }}>
                <h4 style={{ width: "42px", marginRight: "9px" }}>
                  {domain.code === "magnet_resources" ? "Percent Strained" : "Percent Positive"}
                </h4>
                {yoy && <h4 style={{ width: "17px", marginRight: "15px" }}>YOY</h4>}
                <h4 style={{ width: "200px", textAlign: "left" }}>
                  {domain.code === "magnet_resources" ? "Percent Strained" : "Percent Positive / Neutral / Negative"}
                </h4>
                <h4 style={{ width: "55px" }}>
                  {!showAllQuestionPercentiles
                    ? ""
                    : domain.code === "magnet_resources"
                      ? "Strained Percentile"
                      : domain.negative ? "Negative Percentile" : "Positive Percentile"}
                </h4>
              </div>
              <h4>{domain.name === "Learning Environment" ? "Improvement Readiness" : domain.name}</h4>
              {domainPrefixes[domain.code] && <p className="question-prefix">{domainPrefixes[domain.code]}</p>}
              {questionComponents}
            </Domain>
          );
        }

        const {
          magnet_quality,
          magnet_leadership,
          magnet_autonomy,
          magnet_interprof,
          magnet_teamwork,
          magnet_prof_dev,
          magnet_resources,
        } = domainComponents;
        const pages = [];
        pages.push(
          this.getPage([magnet_quality, magnet_leadership, magnet_autonomy, magnet_interprof], 0, magnetReport, unit)
        );
        pages.push(this.getPage([magnet_teamwork, magnet_prof_dev, magnet_resources], 1, magnetReport, unit));
        return <Wrapper>{pages}</Wrapper>;
      } else {
        return (
          <Printable />
          // <ProgressWrap>
          //   <div style={{ marginBottom: "7px", textAlign: "left" }}>Loading results for all survey items...</div>
          //   <Progress
          //     percent={Math.min(Math.floor(questions.progress), 100)}
          //     active
          //     progress="percent"
          //     color="orange"
          //   />
          // </ProgressWrap>
        );
      }
    } else {
      return (
        <BigButton onClick={this.props.toggleShowAllQuestions} style={{ marginBottom: unit ? "166px" : "" }}>
          <Icon name="plus" /> Display results for <strong>ALL</strong> survey items
          <img src={arrow} alt="" />
        </BigButton>
      );
    }
  }
}
export default connect(store => {
  return {
    magnetReport: store.magnetReport.magnetReport,
    domainScores: store.domainScores.domainScores,
    questions: store.questions,
  };
})(Questions);



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/Questions/index.jsx